import React, { useState, useEffect } from "react";
import Menu from "../Menu/Menu";
import { useDBContext } from "../../Context/DBcontext";
import ArticlesItemList from "./ArticlesItemList";
import InputWlabel from "../Inputs/InputWlabel";
import {
  collection,
  getFirestore,
  getDocs,
  writeBatch,
  where,
  query,
  documentId,
} from "firebase/firestore";
import { useUsersContext } from "../../Context/UsersContext";
import LoaderAdmin from "../LoaderAdmin";

export default function Articles() {
  const {
    getArticles,
    getAuthors,
    getCategories,
    getDrafts,
    articles,
    drafts,
    categories,
    authors,
  } = useDBContext();

  const { loggedData } = useUsersContext();

  const [category, setCategory] = useState(null);
  const [author, setAuthor] = useState(null);
  const [position, setPosition] = useState(null);
  const [onlyDrafts, setOnlyDrafts] = useState(false)
  const [search, setSearch] = useState("");
  const [render, setRender] = useState(0);
  const db = getFirestore();

  const [filteredArticles, setFilteredArticles] = useState([]);

  const showDrafts = () => {
    setOnlyDrafts(!onlyDrafts)
  }

  useEffect(() => {
    let filtered = articles;

    if (category) {
      filtered = filtered.filter((article) => article.category === category);
    }

    if (author) {
      filtered = filtered.filter((article) => article.author === author);
    }

    if (position) {
      filtered = filtered.filter((article) => article.position === position);
    }

    if (onlyDrafts) {
      filtered = filtered.filter((article) => article.draft == true);
    }

    if (search.length > 2) {
      filtered = filtered.filter(
        (article) =>
          article.title.toLowerCase().includes(search.toLowerCase()) ||
          (article.tags &&
            article.tags.some((tag) =>
              tag.toLowerCase().includes(search.toLowerCase())
            ))
      );
    }

    setFilteredArticles(filtered);
  }, [category, author, position, articles, search, onlyDrafts]);

  useEffect(() => {
    if (articles.length === 0) {
      getArticles();
    }

    if (drafts.length === 0) {
      getDrafts();
    }

    if (categories.length === 0) {
      getCategories();
    }

    if (authors.length === 0) {
      getAuthors();
    }
  }, []);

  useEffect(() => {
    getArticles();
  }, [render]);

  const tagToSearch = (a) => {
    setSearch(a);
  };

  function reemplazarGuionesPorEspacios(texto) {
    return texto.replace(/-/g, " ");
  }

  const positions = ["portada", "medio", "abajo"];

  const [currentPage, setCurrentPage] = useState(1);
  const articlesPerPage = 10; // Número de artículos por página
  let articlesOfThisCategory = filteredArticles;

  const indexOfLastArticle = currentPage * articlesPerPage;
  const indexOfFirstArticle = indexOfLastArticle - articlesPerPage;
  const currentArticles = articlesOfThisCategory.slice(
    indexOfFirstArticle,
    indexOfLastArticle
  );

  const totalPages = Math.ceil(articlesOfThisCategory.length / articlesPerPage);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const changeStatus = async (id, enabled) => {
    const arrId = [id];
    const batch = writeBatch(db);
    const queryCollection = collection(db, "articles");

    const queryStatus = await query(
      queryCollection,
      where(
        documentId(),
        "in",
        arrId.map((e) => e)
      )
    );

    if (enabled === true) {
      await getDocs(queryStatus)
        .then((resp) =>
          resp.docs.forEach((res) => {
            return batch.update(res.ref, { enabled: false });
          })
        )
        .finally(
          setTimeout(() => {
            setRender(render + 1);
          }, 1000)
        );
    } else {
      await getDocs(queryStatus)
        .then((resp) =>
          resp.docs.forEach((res) => {
            return batch.update(res.ref, { enabled: true });
          })
        )
        .finally(
          setTimeout(() => {
            setRender(render + 1);
          }, 1000)
        );
    }

    batch.commit();
  };

  return (
    <div className="admin-section-cont">
      {loggedData ? (
        <>
          <Menu />
          <div className="admin-section-cont-column">
            <div className="editor-toolbar">
              <InputWlabel
                att="category"
                classes="w20"
                label="Categoría"
                column={true}
                options={true}
                array={categories}
                fromDB={true}
                onchange={(e) => setCategory(e.target.value)}
              />

              <InputWlabel
                att="author"
                classes="w20"
                label="Autores"
                column={true}
                options={true}
                array={authors}
                fromDB={true}
                onchange={(e) => setAuthor(e.target.value)}
              />

              <InputWlabel
                classes="w20"
                att="position"
                label="Posición"
                column={true}
                options={true}
                array={positions}
                onchange={(e) => setPosition(e.target.value)}
              />

              <div className="inputWlabel column-flex-start w20 position-relative">
                <label className="inputwlabel-label" htmlFor="search">
                  {" "}
                  Búsqueda{" "}
                </label>

                <input
                  className="articles-editor-topbar-input"
                  placeholder={
                    search.length > 0 ? search : "Buscar por título o tag"
                  }
                  type="text"
                  onChange={(e) => setSearch(e.target.value)}
                />

                {search.length > 2 ? (
                  <img
                    className="delete-search"
                    onClick={() => {
                      setSearch("");
                    }}
                    width="15"
                    height="15"
                    src="https://img.icons8.com/color/48/cancel--v1.png"
                    alt="cancel--v1"
                  />
                ) : (
                  <></>
                )}
              </div>

              <button onClick={showDrafts} className="buttonbyn">
                Borradores
              </button>
            </div>

            <ArticlesItemList
              articles={currentArticles}
              changeStatus={changeStatus}
              tagToSearch={tagToSearch}
            />

            <div className="row gap05rem">
              <button
                className="buttonbyn"
                onClick={prevPage}
                disabled={currentPage === 1}
              >
                Anterior
              </button>

              <button
                className="buttonbyn"
                onClick={nextPage}
                disabled={currentPage === totalPages}
              >
                Siguiente
              </button>
            </div>
            <span className="font-mont ">
              Página {currentPage} de {totalPages}
            </span>
          </div>
        </>
      ) : (
        <LoaderAdmin loggedData={loggedData} />
      )}
    </div>
  );
}
